import { memo } from 'react';
import { Badge, Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import MemberAvatar from '../shared/MemberAvatar';

/**
 * Step 1 of the bulk Remove: who is included, each with what happens to them, then Cancel and
 * Continue.
 *
 * @param {object} props
 * @param {{ id: string, displayName: string, email: string }[]} props.members Members about to be removed.
 * @param {() => void} props.onCancel
 * @param {() => void} props.onContinue
 */
const MembersRemoveStep1 = ({ members, onCancel, onContinue }) => {
  const { t } = useTranslation('people-access');

  return (
    <>
      <ul
        className="scrollbar-aimsos-auto-sm flex max-h-72 flex-col divide-y divide-edge overflow-y-auto px-6 py-2"
        data-testid="members-remove-list"
      >
        {members.map((member) => (
          <li key={member.id} className="flex items-center gap-3 py-2.5">
            <MemberAvatar member={member} size="md" />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-content">{member.displayName}</p>
              <p className="truncate text-xs text-content-muted">{member.email}</p>
            </div>
            <Badge size="small" variant="error">
              {t('members.remove.losesAccess')}
            </Badge>
          </li>
        ))}
      </ul>
      <div className="flex justify-end gap-2 px-6 py-4">
        {/* The safe choice takes the focus, on open and again after Back from step 2. */}
        <Button variant="secondary" size="sm" data-autofocus autoFocus onClick={onCancel}>
          {t('members.remove.cancel')}
        </Button>
        <Button size="sm" onClick={onContinue}>
          {t('members.remove.continue')}
        </Button>
      </div>
    </>
  );
};

export default memo(MembersRemoveStep1);
